import { render, staticRenderFns } from "./zd-yjk.vue?vue&type=template&id=185bf828&scoped=true&"
import script from "./zd-yjk.vue?vue&type=script&lang=js&"
export * from "./zd-yjk.vue?vue&type=script&lang=js&"
import style0 from "./zd-yjk.vue?vue&type=style&index=0&id=185bf828&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185bf828",
  null
  
)

export default component.exports